<template>
<!--报警数据-->
<div class="alarm-data">
    <div class="content">
        <div class="content-left">
            <div class="content-left-top charts-box">
                <div class="echarts-title">区域报警数量排行</div>
                <echartsScrollBar v-if="hasRankData" :echartsData="alarmDataRank" id='userScrollBar' width="80%" height="100%" />
            </div>
            <div class="content-left-bottom charts-box">
                <div class="echarts-title">区域事件处置结果</div>
                <echartsRadar v-if="hasTypeData" :labelData='typeCountData' id='userPie' width="100%" height="calc(40vh - 70px - 45px)" />
            </div>
        </div>
        <div class="AMap-BOX">
            <div class="content-middle-map">
                <echartsMap type="alarm" :areaId="areaId" @clickMap="mapClick" :markData="alarmDataRank" width="100%" height="100%"></echartsMap>
            </div>
            <div class="content-middle-line charts-box">
                <div class="echarts-title">区域12个月内报警次数曲线图</div>
                <echartsline type="alarm" v-if="hasCountInfo" :showMonth="showMonth" :currentIndex="currentIndex" :dateYearNow="dateYearNow" :echartsData="CountInfoData" @DateClick="DateClick" @monthClick="monthClick" id='userLine' width="100%" height="calc(30vh - 70px - 45px)" />
            </div>
        </div>
        <div class="content-right">
            <div class="content-right-top charts-box">
                <div class="echarts-title-right">区域报警数/处警数</div>
				<div class="userNum">{{totalNum}}<span style="font-size: 12px;">(报警数)</span> </div>
                <div class="userNum">{{quantityNum}}<span style="font-size: 12px;">(处警数)</span></div>
            </div>
            <div class="content-right-middle charts-box">
                <div class="echarts-title-right">报警高发区域</div>
                <echartsMoreBar type="alarm" v-if="highReport" :echartsData="alramGroupNum" id='alarmBar2' width="100%" height="calc(42vh - 70px - 30px)" />
            </div>
            <div class="content-right-bottom charts-box">
                <div class="echarts-title-right">区域7日内处警数量</div>
                <echartsBar id='alarmBar' v-if="hasWeekDaysData" :echartsData="weekDaysData" width="100%" height="calc(40vh - 70px - 30px)" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import echartsBar from '../charts-component/bar-alarm.vue'
import echartsMoreBar from '../charts-component/moreBar.vue'
import echartsScrollBar from '../charts-component/barScroll.vue'
import echartsRadar from '../charts-component/radar.vue'
import echartsline from '../charts-component/line.vue'
import echartsMap from '../charts-component/map.vue'
import publicFn from '../../../assets/js/publicFn.js'
import {
    cloudApi
} from '../../../api-path/cloud-api.js'
export default {
    name: "dataAlarm",
	props:['clouldAreaCode'],
    components: {
        echartsBar,
        echartsRadar,
        echartsScrollBar,
        echartsline,
        echartsMap,
        echartsMoreBar
    },
    data() {
        return {
            alarmDataRank: [], //区域报警数量排行
            hasRankData: false,
            quantityNum: 0, //出警量
            totalNum: 0, //报警量
            alramGroupNum: [], //报警高发区域
            highReport: false,
            typeCountData: [], //事件类型统计
            hasTypeData: false,
            weekDaysData: [], //7日内出警数据量
            hasWeekDaysData: false,
            CountInfoData: [], //区域报警次数数据
            hasCountInfo: false,

            dateYearNow: new Date().getFullYear(), //当前年
            currentIndex: 2,
            showMonth: false,
            areaId: '',
        }
    },
	created() {
		this.areaId=this.clouldAreaCode;
	},
    mounted() {
        this.getAlarmRank()
        this.getAlramGroupNum()
        this.getTotalCount()
        this.getAlarmType()
        this.getCountInfoHour()
        this.getAlramWeekDays()
    },
    watch: {
        areaId(newval, oldVal) {
            if (newval) {
                this.hasRankData = false;
                this.highReport = false;
                this.hasTypeData = false;
                this.hasWeekDaysData = false;
                this.hasCountInfo = false;
                this.getAlarmRank()
                this.getAlramGroupNum()
                this.getTotalCount()
                this.getAlarmType()
                this.getCountInfoHour()
                this.getAlramWeekDays()
            }
        },
		clouldAreaCode(newVal,oldVal){
			if(newVal){
				this.areaId=newVal;
			}
		}
    },
    methods: {
        //区域报警数量排行
        getAlarmRank() {
            this.$http.get(cloudApi.alramAreaInfo, {
                params: {
                    areaId: this.areaId
                }
            }).then(res => {
                if (res.status === 200) {
                    this.hasRankData = true;
                    this.alarmDataRank = res.result;
                }
            })
        },
        //地图点击-切换区域
        mapClick(value) {
            this.areaId = value.adcode;
        },
        //报警/出警总数
        getTotalCount() {
            this.$http.get(cloudApi.alramTotalCount, {
                params: {
                    areaId: this.areaId
                }
            }).then(res => {
                if (res.status == 200) {
                    this.quantityNum = publicFn.formatNum(res.result.quantityNum.toString(), ',', 3);
                    this.totalNum = publicFn.formatNum(res.result.totalNum.toString(), ',', 3);
                }
            })
        },
        //区域报警高发区域
        getAlramGroupNum() {
            this.$http.get(cloudApi.alramGroupNum, {
                params: {
                    areaId: this.areaId
                }
            }).then(res => {
                if (res.status == 200) {
                    this.highReport = true;
                    this.alramGroupNum = res.result;
                }
            })
        },

        //区域事件处置结果
        getAlarmType() {
            this.$http.get(cloudApi.alramTypeCount, {
                params: {
                    areaId: this.areaId
                }
            }).then(res => {
                if (res.status == 200) {
                    this.hasTypeData = true;
                    this.typeCountData = res.result.map(item => {
                        return {
                            name: item.type,
                            value: item.num
                        }
                    })
                }
            })
        },

        //区域内7日出警数量
        getAlramWeekDays() {
            this.$http.get(cloudApi.alramWeekDays, {
                params: {
                    areaId: this.areaId
                }
            }).then(res => {
                if (res.status == 200) {
                    this.hasWeekDaysData = true;
                    this.weekDaysData = res.result;
                }
            })
        },
        //年月统计
        getCountInfoHour(date) {
            this.$http.get(cloudApi.alramCountInfoHour, {
                params: {
                    areaId: this.areaId,
                    date: date ? date : this.dateYearNow
                }
            }).then(res => {
                if (res.status == 200) {
                    this.hasCountInfo = true;
                    this.CountInfoData = res.result;
                }
            })
        },
        //切换月日
        monthClick(value) {
            this.hasCountInfo = false;
            this.dateYearNow = value.year;
            this.currentIndex = value.index;
            this.showMonth = value.showMonth;
            this.getCountInfoHour(value.year);
        },
        //切换到天
        DateClick(value) {
            this.hasCountInfo = false;
            this.showMonth = value.showMonth;
            this.getCountInfoHour(value.month);
        },
        //地图点击-切换区域
        mapClick(value) {
            console.log(value)
            this.areaId = value.adcode;
        }

    }
}
</script>

<style lang="less" scoped>
@import "./../cloud-picture";

.alarm-data {
    .content {
        .content-right {
            .content-right-top {
                height: calc(18vh - 2.0625rem - 0.625rem);
            }

            .content-right-middle {
                height: calc(42vh - 34px - 40px - 10px);
            }
        }
    }

    .userData-pie {
        display: flex;

        .label {
            color: #fff;

            .label-item {
                display: flex;
                flex-direction: column;
                background: url(../../../assets/GIS/alert_small.png);
                background-size: 100% 100%;
                width: 6rem;
                height: 3rem;
                justify-content: center;
                align-items: center;
                margin-bottom: 10px;

                span {
                    &:nth-child(1) {
                        color: #ddd;
                        font-size: .6rem;
                        margin-bottom: 4px;
                    }

                    &:nth-child(2) {
                        color: #fff;
                        font-size: 1rem;
                    }
                }
            }
        }
    }

    .userNum {
        font-size: 2rem;
        color: #fff;
        text-align: right;
    }
}
</style>
